import {Directive, ElementRef, AfterViewInit, OnDestroy} from '@angular/core';
import {Location} from '@angular/common';
import {Router, NavigationEnd} from '@angular/router';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[myHighlightActiveItems]',
  standalone: false,
})
export class HighlightActiveItemsDirective implements AfterViewInit, OnDestroy {
  private routerSubscription: Subscription | null = null;

  constructor(
    private el: ElementRef,
    private location: Location,
    private router: Router,
  ) {}

  ngAfterViewInit() {
    const navElement = this.el.nativeElement;
    const links = navElement.querySelectorAll('a');

    const highlightActive = () => {
      const path = location.hash;
      // console.log(path);

      links.forEach((link: HTMLAnchorElement) => {
        const li = link.parentElement;
        if (!li || li.tagName !== 'LI') return;

        const href = link.getAttribute('href');
        // console.log(href);

        if (li.classList.contains('active')) {
          li.classList.remove('active');
        }
        if (href && path.indexOf(href) === 0) {
          li.classList.add('active');
        }
      });
    };

    highlightActive();

    this.routerSubscription = this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        highlightActive();
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
